<template>
	<div id="Checkout" class="checkout-page px-3">

        <!-- Loading -->
		<div v-if="loading && step !== 5" class="container">
			<div class="row">
				<div class="col-12 text-center">
					<i class="fas fa-spinner fa-2x fa-spin"></i>
				</div>
			</div>
		</div>

        <!-- Titulo e botão voltar -->
		<div v-if="!loading || step == 5" class="container">
            <div>
			    <div class="row align-items-center my-3 position-relative">
                    <checkoutHeader :unavailable="unavailable" :statusPayment="statusPayment" @prev="prev" @goDashboard="goDashboard"/>
                    <div class="row align-items-center justify-content-between my-3" >
                        <div class="col-auto text-left pr-0 ml-1">
                            <h4 class="m-0">{{ titleStep }}</h4>
                        </div>
                    </div>

                    <!-- Etapa 1 e tipo de pagamento = contrato -->
                    <div
                        class="col-auto pl-0 cupom--text"
                        v-if="step == 1 && typePayment == 'contract'">
                        <p class="m-0" @click="showModal">
                            {{ verifyCupom }}
                            <span class="active--cupom">{{ cupom.name }}</span>
                        </p>
                    </div>
			    </div>

                <!-- Lista de planos e dados de pagamento vazio -->
                <div v-if="listPlans.length == 0 && !billData" class="row mt-5">
                    <div class="col-12 text-center align-self-end pb-3 mt-4">
                        <a
                            href="https://web.whatsapp.com/send?phone=351967931480&text=Oi"
                            target="_blank"
                        >
                            <button class="btn btn-lg btn-primario" @click="prev">
                                Fale conosco
                                <i class="fab fa-whatsapp"></i>
                            </button>
                        </a>
                    </div>
                </div>

				<!-- 1 - Seleção do plano e valor a ser pago -->
                <ChoosePlan
                    ref="choosePlan"
                    v-show="step == 1"
                    :typePayment="typePayment"
                    :listPlans="listPlans"
                    :activePaymentMethod="activePaymentMethod"
                    :priceOptions="priceOptions"
                    :activePrice="activePrice"
                    :cupom="cupom"
					:billData="billData"
                    @onActivePrice="activePrice = $event"
                    @paymentMethod="activePaymentMethod = $event"
                    :forward="forward"
                    @errorNumbers="errorNumbers = $event"
                />

				<!-- 2 - Dados pessoais  -->
                <PersonalData
                    ref="personalData"
                    v-show="step == 2"
                    :typePayment="typePayment"
                    :userData="userData"
                    @errorNumbers="errorNumbers = $event"
                />

                <!-- 3 - Dados de endereço -->
                <AddressData
                    ref="addressData"
                    v-show="step == 3"
                    :userAddressData="userAddressData"
                    @errorNumbers="errorNumbers = $event"
                />

				<!-- 4 - Dados de cartão de crédito -->
				<CreditCard
                    ref="creditCard"
                    v-show="step == 4 && activePaymentMethod !== 'Boleto'"
                    :userCardData="userCardData"
                    @errorNumbers="errorNumbers = $event"
                />

				<!-- 5 - Envio e resultado dos dados de pagamento -->
                <Result
                    v-show="step == 5"
                    :loading="loading"
                    :statusPayment="statusPayment"
                    :errorMessage="errorMessage"
                    :boleto="boleto"
                    @tryAgain="sendPayment()"
                    @back="step = 1"
                    @goDashboard="goDashboard()"
                />

                <!-- Botão avançar etapas -->
				<div class="row">
					<div
						class="col-12 text-center align-self-end pb-3 d-flex justify-content-center"
						v-if="step <= 4"
					>
						<button
							:disabled="isBusy"
							class="btn btn-large btn-primario d-flex align-items-center"
							@click="confirmData"
						>
							{{ (step == 3 && activePaymentMethod == 'Boleto') || step == 4 ? 'Finalizar' : 'Continuar' }}
						<i v-if="loading" class="fal fa-spinner fa-spin fa-2x ml-2"></i>
					</button>
					</div>
				</div>
			</div>
		</div>

        <!-- Modal cupom -->
		<b-modal
			ref="cupomModal"
			hide-footer
			centered
			size="md"
			title="Adicionar cupom"
			@hide="resetCupom"
		>
			<div class="d-block text-left">
				<div class="row">
					<div class="col-12 form-group" v-if="!isBusy">
						<label for="inputCupom">Digite o cupom</label>
						<input
							type="text"
							placeholder="Seu cupom"
							class="form-control"
							v-model="nameCupom"
							@keyup.enter="applyCupom"
						/>
						<span v-if="errorCupom" class="error--cupom">{{
							errorCupom
						}}</span>
					</div>
					<div class="col-12 text-center loading--spinner" v-else>
						<i class="fas fa-spinner fa-spin"></i>
					</div>
					<div class="col-12 text-right">
						<button
							class="btn btn-primario btn-sm"
							@click="applyCupom"
						>
							Aplicar
						</button>
					</div>
				</div>
			</div>
		</b-modal>

	</div>
</template>

<script>
	import axios from "axios";

	import checkoutHeader from "../molecules/CheckoutHeader";
    import ChoosePlan from '../organisms/CheckoutStepChoosePlan.vue'
    import PersonalData from '../organisms/CheckoutStepPersonalData.vue'
    import AddressData from '../organisms/CheckoutStepAddressData.vue'
    import CreditCard from '../organisms/CheckoutStepCreditCard.vue'
    import Result from '../organisms/CheckoutStepResult.vue'

	export default {
		name: "checkout",
		data() {
			return {
				chekcoutToken: "",
				typePayment: "contract",
				step: 1,
				listPlans: [],
				priceOptions: [],
				wizardDate: null,
				previousRoute: null,
				forward: 0,
				userHash: null,
				billData: {},
				loading: true,
				boleto: {
					status: 0,
					barcode: null,
					url: null,
				},
				cupom: {
					id: null,
					name: null,
					discount: 0,
				},
				errorCupom: null,
				nameCupom: null,
				activePrice: null,
				isBusy: false,
				activePaymentMethod: null,
				token: null,
				statusPayment: null,
				userData: {
					name: "",
					birthDate: "",
					documentId: "",
					phone: "",
					email: "",
					personType: "personal",
					responsible: "",
				},
				userAddressData: {
					zipCode: "",
					streetName: "",
					addressNumber: "",
					district: "",
					complement: "",
					city: "",
					province: "",
					country: "",
				},
				userCardData: {
					cardName: "",
					cardNumber: "",
					cardValidate: "",
					cardCode: "",
					cardBrand: "",
				},
				unavailable: false,
				errorNumbers: 0,
                errorMessage: ""
			};
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				vm.previousRoute = from;
			});
		},
		components: {
			checkoutHeader,
            ChoosePlan,
            PersonalData,
            AddressData,
            CreditCard,
            Result,
		},
		watch: {
			activePrice() {
				this.generatePrices();
			},
		},
		computed: {
			titleStep() {
				if (this.step == 1) return "Pagamento";
                else if (this.step == 2) return "Seus dados";
                else if (this.step == 3) return "Endereço";
                else if (this.step == 4) return "Dados do cartão";
                else if (this.step == 5 ) //Resultados
					if(this.loading == true) return "Processando Pagamento";
                    else if(this.statusPayment !== 1) return "Pagamento recusado";
                    else if(this.statusPayment == 1 && !this.boleto.barcode) return "Pagamento aprovado";
                    else if(this.statusPayment == 1 && this.boleto.barcode) return "Boleto bancário";
			},
			verifyCupom() {
				if (this.cupom.name) {
					return "Cupom:";
				} else {
					return "Inserir cupom";
				}
			},
		},
		methods: {
			checkPaymentType,
			prev,
			next,
			showModal,
			hideModal,
			validateToken,
			confirmData,
			sendPayment,
			sendNewPayment,
			sendOldPayment,
			applyCupom,
			resetCupom,
			generatePrices,
			goDashboard,
		},
		created() {
			this.checkPaymentType();
		},
	};

	function checkPaymentType() {
		let token = this.$route.query.token,
			typeURL = "c";
		if (!token) {
			token = this.$route.query.b;
			typeURL = "b";
			this.typePayment = "bill";
		}
		if (token) {
			this.chekcoutToken = token;
			this.validateToken(token, typeURL);
		} else {
			this.$router.push("/dashboard");
		}
	}

	function prev() {
		if (this.step == 1) {
			if (
				this.previousRoute &&
				this.previousRoute.path == "/login/application"
			) {
				let cupomUrl = `https://${this.$store.state.application.app_base_domain}/c/${this.$store.state.user.usingCode}`;
				window.location.href = cupomUrl;
			} else {
				if (this.wizardDate) {
					this.$router.push("/dashboard");
				} else {
					let cupomUrl = `https://${this.$store.state.application.app_base_domain}/c/${this.$store.state.user.usingCode}`;
					window.location.href = cupomUrl;
				}
			}
		} else if (this.step <= 4) {
			this.step = this.step - 1;
		} else {
			this.step = 1;
		}
	}
	function next() {
		if (this.step == 3 && this.activePaymentMethod == "Boleto") {
			this.sendPayment()
            this.step = 5
		}
		if (this.step == 4) {
			this.sendPayment();
		}
		if (this.step <= 3) {
			this.step++;
		}
	}
	function showModal() {
		this.$refs["cupomModal"].show();
	}
	function hideModal(params) {
		this.$refs["cupomModal"].hide();
	}
	function validateToken(token, typeURL) {
		axios({
			method: "get",
			url: `${process.env.ROOT_API}api/financial/access/validate?${typeURL}=${token}`,
			data: "",
		}).then((response) => {
			this.loading = false;
			if (response.data.status == 1) {
				if (typeURL == "b") {
					if (response.data.data.bill.status == 'paid') {
						this.step = 5;
						this.unavailable = true;
                        this.statusPayment = 1;
					} else if (response.data.data.bill.status == 'canceled') {
                        this.step = 5;
						this.unavailable = true;
                        this.statusPayment = 6;
                    } else {
						this.billData = response.data.data.bill;
						this.generatePrices();
					}
				} else {
					if (response.data.data.contract.status == 'active' && response.data.data.contract.isTrial == 0) {
						this.step = 5;
						this.unavailable = true;
					} else {
						this.listPlans = response.data.data.plans;
						this.activePrice = this.listPlans[0].id;
						this.nameCupom = response.data.data.user.code;
						this.userHash = response.data.data.user.hash;
						if (this.nameCupom) {
							this.applyCupom();
						}
					}
				}
				Object.keys(response.data.data.user).forEach((key) => {
					if (Object.keys(this.userData).includes(key)) {
						this.userData[key] = response.data.data.user[key];
					}
					if (Object.keys(this.userAddressData).includes(key)) {
						this.userAddressData[key] = response.data.data.user[key];
					}
				});
				this.wizardDate = response.data.data.site.wizardDate;
			} else {
				this.$router.push("/dashboard");
			}
		});
	}
	function confirmData() {
        this.isBusy = true
		if (this.step == 1) this.$refs.choosePlan.checkError(); // Escolha de Planos
        else if (this.step == 2) this.$refs.personalData.checkError(); //Dados Pessoais
        else if (this.step == 3) this.$refs.addressData.checkError(); //Endereço
        else if (this.step == 4) this.$refs.creditCard.checkError(); // Cartão de credito

        setTimeout(() => {
            this.isBusy = false
        }, 20);
        if (this.errorNumbers == 0) this.next();
	}
	async function sendPayment() {
		this.statusPayment = null;
		if (this.typePayment == "bill") this.sendOldPayment();
		else await this.sendNewPayment();
	}
	async function sendOldPayment() {
		this.errorMessage = 'Houve um erro ao processar seu pagamento. Revise os dados e tente novamente. Caso o problema persistir, por favor, entre em contato com nossa equipe de atendimento.';
		this.loading = true
        this.step = 5
		let userData = this.userData,
			userAddressData = this.userAddressData,
			userCardData = this.userCardData,
			formData = {},
			hash = this.chekcoutToken,
			codeId = this.cupom.id,
			activePrice = this.activePrice,
			activePaymentMethod = this.activePaymentMethod;

		formData = {
			'userData' : userData,
			'userActivePrice' : activePrice,
			'userAddressData' : userAddressData,
			'userCardData' : userCardData,
			'activeCode' : codeId,
			'activePaymentMethod' : activePaymentMethod
		}

		await axios({
			method: "post",
			url: `${process.env.ROOT_API}api/bill/pay?b=${hash}`,
			data: formData,
			headers: {
				"Content-type": "application/json",
			},
		})
			.then((response) => {
				var data = response.data;
                if (data.status == 1) {
					this.statusPayment = 1
					if (data.contents.barcode) {
						this.boleto = data.contents;
					}
				} else {
					this.statusPayment = 0;
                    if(data.message){
                        this.errorMessage = data.message;
                    }
				}
			})
			.catch((response) => {
                this.statusPayment = 0
				console.log("Erro realizar pagamento");
			});
        this.loading = false
	}
	async function sendNewPayment() {
		this.errorMessage = 'Houve um erro ao processar seu pagamento. Revise os dados e tente novamente. Caso o problema persistir, por favor, entre em contato com nossa equipe de atendimento.';
		this.loading = true
        this.step = 5
		let userData = this.userData,
			userAddressData = this.userAddressData,
			userCardData = this.userCardData,
			formData = {},
			hash = this.chekcoutToken,
			codeId = this.cupom.id,
			activePrice = this.activePrice,
			activePaymentMethod = this.activePaymentMethod;

			formData = {
				'userData' : userData,
				'userActivePrice' : activePrice,
				'userAddressData' : userAddressData,
				'userCardData' : userCardData,
				'activeCode' : codeId,
				'activePaymentMethod' : activePaymentMethod
			}

		await axios({
			method: "post",
			url: `${process.env.ROOT_API}/api/contract/hire?c=${hash}`,
			data: formData,
			headers: {
				"Content-type": "Application/json",
			},
		})
			.then((response) => {
				var data = response.data;
                if (data.status == 1) {
					this.statusPayment = 1
					if (data.contents.barcode) {
						this.boleto = data.contents;
					}
				} else {
					this.statusPayment = 0;
                    if(data.message){
                        this.errorMessage = data.message;
                    }
                }
			})
            .catch((response) => {
                this.statusPayment = 0
				console.log("Erro realizar pagamento");
			});
			this.loading = false

	}
	function applyCupom() {
		this.errorCupom = "";
		if (!this.nameCupom) {
			this.errorCupom = "Digite o cupom";
		} else {
			this.isBusy = true;
			let hash = this.userHash;
			let code = this.nameCupom;
			this.addCupomInvalidCode = "";
			axios({
				method: "get",
				url: `${process.env.ROOT_API}/api/code/${code}?u=${hash}`,
				headers: {
					"Content-Type": "application/json",
				},
			}).then((response) => {
				if (response.data.status == "1") {
					this.cupom.id = response.data.id;
					this.cupom.name = code;
					this.forward = response.data.forward;
					this.cupom.discount = parseFloat(response.data.discount);
					this.hideModal();
				} else {
					this.errorCupom = "Cupom inválido";
				}
				this.generatePrices();
			});
            this.isBusy = false;
		}
	}
	function resetCupom() {
		this.nameCupom = null;
	}
	function generatePrices() {
		this.priceOptions = [];
		if (this.typePayment == "bill") {
			for (
				let index = 0;
				index < this.billData.installments.length;
				index++
			) {
				this.priceOptions.push({
					text: `${
						this.billData.installments[index].count
					}x de R$ ${this.billData.installments[index].value
						.toFixed(2).replace(".", ",")} sem juros no cartão`,
					value: index + 1,
				});
			}
		} else {
			//Obtendo o plano selecionado
			let mainPrice = this.listPlans.find(
				(price) => price.id == this.activePrice
			);

			//Canculando adesão - desconto do cupom
			let cuponAndSupport = mainPrice.support - this.cupom.discount;

			//Canculando quantidade de parcelas
			let controlPrices = null;
			if (mainPrice.max_installment > mainPrice.price_installments) {
				controlPrices = mainPrice.max_installment;
			} else {
				controlPrices = mainPrice.price_installments;
			}

			//--- Canculando valor das parcelas a na seleção de planos ---//
			//Se não tiver valor de adesão e for mensal
			if (cuponAndSupport == 0 && mainPrice.price_cicle == 1) {
				this.priceOptions.push({
					text: "Cartão de crédito",
					value: 1,
				});
			}
			//Se não tiver valor de adesão e não for mensal
			else if (cuponAndSupport == 0 && mainPrice.price_cicle > 1) {
				for (let index = 0; index < controlPrices; index++) {
					this.priceOptions.push({
						text: `${index + 1}x de R$ ${(
							mainPrice.price_value /
							(index + 1)
						)
							.toFixed(2)
							.replace(".", ",")} sem juros no cartão`,
						value: index + 1,
					});
				}
			}
			//Se tiver valor de adesão e for mensal
			else if (cuponAndSupport > 0 && mainPrice.price_cicle == 1) {
				for (let index = 0; index < controlPrices; index++) {
					this.priceOptions.push({
						text: `${index + 1}x de R$ ${(cuponAndSupport / (index + 1))
							.toFixed(2)
							.replace(".", ",")} sem juros no cartão`,
						value: index + 1,
					});
				}
			}
			//Se tiver valor de adesão e não for mensal
			else if (cuponAndSupport > 0 && mainPrice.price_cicle > 1) {
				let amount = parseFloat(mainPrice.price_value) + parseFloat(cuponAndSupport);
				for (let index = 0; index < controlPrices; index++) {
					this.priceOptions.push({
						text: `${index + 1}x de R$ ${( amount / (index + 1))
						.toFixed(2)
						.replace(".", ",")} sem juros no cartão`,
						value: index + 1,
					});
				}
			}
		}
		this.priceOptions.push({
			text: `A vista no Boleto`,
			value: `Boleto`,
		});
		this.activePaymentMethod = this.priceOptions[0].value;
	}

	function goDashboard() {
		if (!this.wizardDate) {
			this.$router.push("/wizard");
		} else {
			this.$router.push("/dashboard");
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/templates/Checkout.vue